import * as yup from 'yup';

export default yup.object().shape({
  locations: yup.array().of(
    yup.object().shape({
      location: yup.object().shape().nullable(),
      radius: yup.string().test(
        'min',
        'Search radius must be at least 25',
        // eslint-disable-next-line func-names
        function (value) {
          const v = parseInt(value, 10);
          if (this.parent.location !== null
            && !this.parent.location?.types?.includes('administrative_area_level_1')
            && (Number.isNaN(v) || v < 25)) {
            return false;
          }
          return true;
        },
      ),
    }),
  ),
});
